module.exports = __webpack_public_path__ + "static/media/step2.fbe72528.svg";